import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { watchCmaDrafts, cmaMatches, deleteCmaDraft } from '../../services/cmaDrafts';

// Saved CMAs for one person (contact, pipeline record or transaction client). Agents see only their
// own; admins see everyone's. Matches by linked ids, then email/phone.
// bare: no box/header/empty text (the parent shows one combined section); onCount reports how many match.
export default function SavedCmas({ who, compact = false, bare = false, onCount }) {
  const navigate = useNavigate();
  const { user, userRole } = useAuth();
  const isAdmin = userRole === 'Admin';
  const [all, setAll] = useState([]);
  useEffect(() => watchCmaDrafts(user?.uid, isAdmin, setAll), [user?.uid, isAdmin]);
  const mine = useMemo(() => all.filter((d) => cmaMatches(d, who)), [all, who]);
  useEffect(() => { if (onCount) onCount(mine.length); }, [mine.length, onCount]);
  if (!mine.length && (compact || bare)) return null;
  const open = (d) => navigate(`/tools/cma?draft=${encodeURIComponent(d.id)}&owner=${encodeURIComponent(d.ownerUid)}`);
  const del = async (d) => {
    if (!window.confirm(`Delete the saved CMA for ${d.address || 'this property'}?`)) return;
    try { await deleteCmaDraft(d.ownerUid, d.id); } catch (e) { window.alert('Could not delete it. Please try again.'); }
  };
  const btn = { background: '#fff', color: '#1a1a1a', border: '1px solid #D4AF37', borderRadius: 6, padding: '6px 10px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
  return (
    <div style={bare ? { color: '#111' } : { marginTop: 12, padding: 12, border: '1px solid #e5dcc3', borderRadius: 8, background: '#fff', color: '#111', maxWidth: '100%', boxSizing: 'border-box' }}>
      {!bare && <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6 }}>Saved CMAs</div>}
      {!mine.length && <div style={{ fontSize: 13, color: '#555' }}>No saved CMAs for this client yet.</div>}
      {mine.map((d) => (
        <div key={`${d.ownerUid}-${d.id}`} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, padding: '8px 0', borderTop: '1px solid #f0ead8' }}>
          <div style={{ flex: '1 1 180px', minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: 14, overflowWrap: 'anywhere' }}>{d.address || 'Untitled CMA'}</div>
            <div style={{ fontSize: 12, color: '#555' }}>
              <span style={{ display: 'inline-block', padding: '1px 8px', borderRadius: 10, marginRight: 6, fontWeight: 700, background: d.status === 'final' ? '#E3F4EA' : '#FFF4D6', color: d.status === 'final' ? '#1F6B3F' : '#7A5B00' }}>{d.status === 'final' ? 'Final' : 'Draft'}</span>
              Updated {d.updatedAt ? new Date(d.updatedAt).toLocaleDateString() : ''}{isAdmin && d.ownerName ? ` · ${d.ownerName}` : ''}
            </div>
          </div>
          <button style={btn} onClick={() => open(d)}>Open / Edit</button>
          <button style={{ ...btn, borderColor: '#c0392b', color: '#c0392b' }} onClick={() => del(d)}>Delete</button>
        </div>
      ))}
    </div>
  );
}
